import { render, staticRenderFns } from "./PendingActivitiesCarousel.vue?vue&type=template&id=7747bd33&scoped=true&"
import script from "./PendingActivitiesCarousel.vue?vue&type=script&lang=js&"
export * from "./PendingActivitiesCarousel.vue?vue&type=script&lang=js&"
import style0 from "./PendingActivitiesCarousel.vue?vue&type=style&index=0&id=7747bd33&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7747bd33",
  null
  
)

export default component.exports